import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getDashboardAnalytics = createAsyncThunk(
  "dashboard/getDashboardAnalytics",
    async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.get(`/admin/payment-analytics?from_date=${formdata.fromDate}&to_date=${formdata.toDate}`);

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",

  initialState: {
    loading: false,
    dashboard: null,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(getDashboardAnalytics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getDashboardAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboard = action.payload;
      })

      .addCase(getDashboardAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dashboardSlice.reducer;